<template>
	<div class="variant-main-div" v-loading="loading">
		<div class="search-box">
			<el-input placeholder="输入ASIN查询该ASIN相关变体" v-model="search.asin">
				<el-button slot="append" icon="el-icon-search" @click="searchDataFun(null)"></el-button>
			</el-input>
		</div>
		<div class="asin-box">
			<el-collapse v-model="activeNames" class="el-collapse-asin-20220810">
				<el-collapse-item v-for="(item,index) in asinArr" :key="index" :disabled="!item.variants">
					<template slot="title">
						<div style="flex: 1;display: flex">
							<div style="flex: 1;position: relative">
								<asin-info-sub :asinInfo="item" :loading="item.loading"></asin-info-sub>
								<div style="position: absolute;right: 0;bottom: 0" @click.stop>
									<el-checkbox :disabled="item.variantLoading" v-model="item.all" size="mini">包含变体</el-checkbox>&nbsp;
									<el-button @click="primaryAsinAdd(item)"
										:disabled="addedAsins.findIndex(i => i.asin === item.asin) !== -1"
										type="primary"  size="mini">添加ASIN</el-button>
								</div>
							</div>
						</div>
					</template>
					<!--变体-->
<!--					<div class="add-all-div">-->
<!--						<el-row>-->
<!--							<el-col :span="12">-->
<!--								<el-button style="width: 100%"  @click="addAsin(item.variants)">-->
<!--									插入全部变体-->
<!--								</el-button>-->
<!--							</el-col>-->
<!--							<el-col :span="12">-->
<!--								<el-button style="width: 100%" :disabled="addedAsins.findIndex(i => i.asin === item.asin) !== -1"-->
<!--									@click="addAsin([item])">-->
<!--									添加搜索ASIN-->
<!--								</el-button>-->
<!--							</el-col>-->
<!--						</el-row>-->
<!--					</div>-->

					<div class="asin-variant-box" v-for="(variantsItem,index) in item.variants" :key="index">
						<div style="flex: 1">
							<asin-info-sub :asinInfo="variantsItem"  :loading="item.variantLoading"></asin-info-sub>
						</div>
						<div style="width: 50px;writing-mode:vertical-rl;text-align: center">
							<el-button circle icon="el-icon-plus" @click="addAsin([variantsItem])"
								type="primary" :disabled="addedAsins.findIndex(i => i.asin === variantsItem.asin) !== -1"></el-button>
						</div>
					</div>
				</el-collapse-item>
			</el-collapse>
		</div>
	</div>
</template>

<script>
import { api_asin_batchAsinInfoQuery_public } from "@/components/api/asinBasiceInfo";
import ASIN_INFO_SUB from '@/components/template/view/keyword/monitoring2/asin/asinInfoSub'
import { uniqueArr } from "@/components/common/utils/util";

export default {
	name: "variantList",
	inject: ['WINDOW', 'F_alertMsg', 'F_windowLoading', 'F_getErrMSg', 'LOGINUSER'],
	data() {
		return {
			loading: false,
			asinArr: [],
			search: {
				asin: "",
				type : 1
			},
			activeNames : []
		}
	},
	props : {
		addedAsins : {
			default : []
		}
	},
	components: {
		'asin-info-sub' : ASIN_INFO_SUB
	},
	created() {},
	methods: {
		addAsin : function(asinArr){
			let this_ = this
			asinArr.forEach(i => {
				i.product_image = i.imgs[0]
				this_.$emit('addAsin', null, i.asin,i)
			})
		},
		primaryAsinAdd : function(item) {
			let obj = { ...item }
			delete obj.variants
			delete obj.variantLoading
			let asinArr = [ obj ]
			if (item.all){
				asinArr = [...asinArr,...item.variants]
			}
			asinArr.forEach(i => {
				let o
				if (i.imgs){
					i.imgs = i.images
					i.product_image = i.images[0]
					o = i;
				}
				this.$emit('addAsin', null, i.asin,o)
			})
		},
		searchDataFun: function(this_) {
			this_ = this_ || this
			let asin = this_.$data.search.asin.trim()
			let index = this_.$data.asinArr.findIndex(i => i.asin === asin)
			if (index !== -1 || !this_.$data.search.asin) {
				return
			}
			// 开启遮罩
			// this_.$data.loading = true
			this_.$data.asinArr.push({ asin: asin, loading: true ,variantLoading : true})
			api_asin_batchAsinInfoQuery_public([asin], undefined, this_.$data.search.fields).then(res => {
				let asinInfo = res.data[0]
				let index1 = this_.$data.asinArr.findIndex(i => i.asin === asin)
				let obj = this_.$data.asinArr[index1]
				if (asinInfo){
					let obj = Object.assign(asinInfo,obj)
					obj.images = obj.imgs || []
					obj.all = false
					this_.$data.asinArr.splice(index1,1,obj)
					if (asinInfo.variants){
						let asinArr = [ ...uniqueArr(asinInfo.variants) ]
						asinInfo.variants.map(i => { return { asin : i } })
						this_.$options.methods.loadVariantData(this_, asinInfo.asin,asinArr)
					}
				}
				// 关闭父级骨架加载
				this_.$set(this_.$data.asinArr[index1],'loading',false)
				// 关闭遮罩
				// this_.$data.loading = false
			}).catch(err => {
				this_.$data.asinArr.splice(this_.$data.asinArr.findIndex(i => i.asin = asin) ,1)
				console.error(err)
				// 关闭遮罩
				// this_.$data.loading = false
				this_.F_alertMsg('系统繁忙,请稍后再试', 4)
			})
		},
		loadVariantData: function(this_, asin, asins) {
			this_ = this_ || this
			let obj = this_.$data.asinArr.find(i => i.asin === asin)
			api_asin_batchAsinInfoQuery_public(asins, undefined).then(res => {
				obj.variants = res.data.map(i => {
					i.images = i.imgs || []
					return i
				})
				// 关闭骨架
				obj.variantLoading = false
			}).catch(err => {
				// 关闭骨架
				obj.variantLoading = false
				console.error(err)
			})
		}
	}

}
</script>

<style scoped>
.variant-main-div {
}
.asin-box {
	margin: 20px 0;
}
.add-all-div{
	margin-top: 20px;
}
.asin-variant-box {
	padding-left: 20px;
	display: flex;
}
</style>
<style>
.el-collapse-asin-20220810 > .el-collapse-item .el-collapse-item__header{
	height: auto !important;
}
</style>